import { render, staticRenderFns } from "./OrdersRightPanel.vue?vue&type=template&id=ab30e10a"
import script from "./OrdersRightPanel.vue?vue&type=script&lang=js"
export * from "./OrdersRightPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports